// @ts-nocheck
/* eslint-disable max-len */
import { Command } from '../type/common.interface';

/**
 * 命令对应的绘制函数
 */
const commandHandlers: {
    [key in Command['type']]: (ctx: CanvasRenderingContext2D, command: Command) => void;
} = {
    B: (ctx: CanvasRenderingContext2D) => ctx.beginPath(),
    M: (ctx: CanvasRenderingContext2D, command: Command) => ctx.moveTo(command.x, command.y),
    L: (ctx: CanvasRenderingContext2D, command: Command) => ctx.lineTo(command.x, command.y),
    Q: (ctx: CanvasRenderingContext2D, command: Command) => ctx.quadraticCurveTo(command.x1, command.y1, command.x, command.y),
    C: (ctx: CanvasRenderingContext2D, command: Command) => ctx.bezierCurveTo(command.x1, command.y1, command.x2, command.y2, command.x, command.y),
    A: (ctx: CanvasRenderingContext2D, command: Command) => ctx.arcTo(command.x1, command.y1, command.x2, command.y2, command.r),
    Z: (ctx: CanvasRenderingContext2D) => ctx.closePath(),
};

/**
 * 在canvas上绘制路径命令
 */
export function execute(ctx: CanvasRenderingContext2D, commands?: Command[]) {
    if (!commands) return;
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (let i = 0; i < commands.length; i++) {
        const command = commands[i];
        const handler = commandHandlers[command.type];
        handler(ctx, command);
    }
}
